// src/hooks/useNavigationActions.ts
import { useSearchParams } from "react-router-dom";

export const useNavigationActions = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const closeModal = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("product");
    params.delete("cartItem");
    setSearchParams(params);
  };

  return { closeModal };
};
